import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const LOCATION_CONSTANTS = {
  id: 'admin.system.location',
  title: 'Ubicaciones Geográficas',

  labels: {
    ...COMMONS,
    altCode: `${COMMONS.code} Alterno`,
    saveSuccess: 'La ubicación se guardó exitosamente!'
  },

  actions: {
    ...ACTIONS,
    add: `${ACTIONS.add} Ubicación`,
    edit: `${ACTIONS.edit} Ubicación`
  }
};
